(function () {
  "use strict";

  function initHomepage(root) {
    if (!root || root.dataset.homeReady === "true") return;
    root.dataset.homeReady = "true";

    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-home-tab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-home-panel]"));

    function selectTab(tab, focusTab) {
      var key = tab.getAttribute("data-home-tab");

      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute("aria-selected", active ? "true" : "false");
        item.setAttribute("tabindex", active ? "0" : "-1");
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute("data-home-panel") !== key;
      });

      if (focusTab) tab.focus();
    }

    var initialIntent = null;
    try {
      initialIntent = new URLSearchParams(window.location.search || "").get("intent");
    } catch (_) {}
    if (["love", "career", "decision", "self", "timing", "symbol"].indexOf(initialIntent) !== -1) {
      var initialTab = tabs.filter(function (tab) {
        return tab.getAttribute("data-home-tab") === initialIntent;
      })[0];
      if (initialTab) selectTab(initialTab, false);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        selectTab(tab, false);
      });

      tab.addEventListener("keydown", function (event) {
        var nextIndex = null;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          selectTab(tabs[nextIndex], true);
        }
      });
    });

    root.querySelectorAll("[data-home-event]").forEach(function (link) {
      link.addEventListener("click", function () {
        var eventName = link.getAttribute("data-home-event");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "deckaura_home_cta", home_cta: eventName });
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-home-enterprise]").forEach(initHomepage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initHomepage(event.target.querySelector("[data-home-enterprise]"));
  });
})();
